// Transport — the queue + batch scheduler + network. Fire-and-forget by design:
// enqueue() returns in microseconds and never throws. Flushes batch into one request;
// on tab hide/close uses sendBeacon so in-flight events survive unload.

import { config } from "./config"

let queue = []
let timer = null

function log(...args) {
    if (config.debug) console.debug("[analytics]", ...args)
}

function schedule() {
    if (timer) return
    timer = setTimeout(() => { timer = null; flush() }, config.flushIntervalMs)
}

// Periodic / size-triggered flush via fetch with keepalive (non-blocking, survives a
// soft navigation). Errors are swallowed — analytics must never disturb the app.
function flush() {
    if (!queue.length) return
    const batch = queue
    queue = []
    const body = JSON.stringify({ batch })
    try {
        fetch(config.endpoint, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body,
            keepalive: true,
            credentials: "same-origin",
        }).catch(() => { /* best-effort: drop on failure */ })
        log("flushed", batch.length)
    } catch {
        /* fetch threw synchronously (very rare) — drop the batch, never bubble up */
    }
}

// Force everything out now, preferring sendBeacon (guaranteed-ish on unload). Used on
// pagehide / visibility-hidden.
export function flushBeacon() {
    if (!queue.length) return
    const batch = queue
    queue = []
    try {
        const blob = new Blob([JSON.stringify({ batch })], { type: "application/json" })
        const ok = navigator.sendBeacon?.(config.endpoint, blob)
        if (!ok) flushViaKeepalive(batch)
        log("beacon", batch.length)
    } catch {
        /* swallow */
    }
}

function flushViaKeepalive(batch) {
    try {
        fetch(config.endpoint, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ batch }),
            keepalive: true,
            credentials: "same-origin",
        }).catch(() => {})
    } catch { /* swallow */ }
}

export function enqueue(envelope) {
    queue.push(envelope)
    // Bounded queue: drop oldest beyond the cap so a dead API can't grow memory.
    if (queue.length > config.maxQueueSize) {
        queue.splice(0, queue.length - config.maxQueueSize)
    }
    if (queue.length >= config.batchSize) flush()
    else schedule()
}
